import type { LocationQueryValue } from "vue-router"

export function parseNumberQueryParam(value: LocationQueryValue | LocationQueryValue[]): number {
  const raw = Array.isArray(value) ? value[0] : value
  const n = Number(raw)
  if (!Number.isFinite(n)) {
    throw new Error(`Expected numeric query param, got ${JSON.stringify(raw)}`)
  }
  return n
}

/** Soft variant of `parseNumberQueryParam` — returns undefined for missing/invalid instead of throwing. */
export function tryParseNumberQueryParam(value: unknown): number | undefined {
  const raw = Array.isArray(value) ? value[0] : value
  const n = Number(raw)
  return Number.isFinite(n) ? n : undefined
}
